.footer {
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 4);

  gz-button {
    line-height: 0.75;
    margin-left: -2px; // offset of the original padding of gz-button
  }
}
